//@flow
type Country = {
  code: string,
  code3: string,
  name: string,
  phonePrefix: string,
  type: string,
};

export type DefaultTaxInvoiceType = {
  country: Country,
  label: string,
  name: string,
};

export const TAX_INVOICE_TYPES: DefaultTaxInvoiceType[] = [
  {
    country: {
      code: 'PE',
      code3: 'PER',
      name: 'Peru',
      phonePrefix: '51',
      type: 'country',
    },
    label: 'Boleta',
    name: 'BOLETA',
  },
  {
    country: {
      code: 'PE',
      code3: 'PER',
      name: 'Peru',
      phonePrefix: '51',
      type: 'country',
    },
    label: 'Factura',
    name: 'FACTURA',
  },
];
